import { useState } from 'react'
import styled from '@emotion/styled';
import { TopDisplay, Button } from '../../../../ui-components';
import { FilterDropDown } from '../../Applicants/Applicants';
import { useDispatch } from 'react-redux';
import apiCall from '../../../../utils/apiCall';
import { useQuery } from '@tanstack/react-query';
import CreateBtn from '../CompanyClass/CreateButton';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { CircularProgress } from '@mui/material';
import { AxiosError } from 'axios';
import styles from '../../Applicants/css/display-applicant.module.css';
import CompanyClassTable from './Table';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../../utils/allRouteId';



interface CompanyClassResponse {
  CompanyClassificationId: number;
  CompanyClassificationTypeId: number;
  CompanyClassificationType: string;
  SectorType: string;
  AnnualSubscription: number;
  IsSubmitted: boolean;
  IsActive: boolean;
}

interface ClassificationResponse {
  StatusCode: number;
  Message: string;
  Data: Classification[];
}

interface Classification {
  Id: number;
  ClassyTypeId: number;
  SectorType: string;
  AnnualSubscription: number;
  IsSubmitted: boolean;
  ActiveStatus: boolean;
  ClassificationType: string;
}

const option1:any= [
  {val:ExNyRoute, name:"Examination / NYSC"},
  {val:PrRoute, name:"Practitioner"},
  {val:ExRoute, name:"Executive"},
  {val:AcRoute, name:"Academic"},
  {val:MiRoute, name:"Military"},
  {val:CoRoute, name:"Corporate"}
]

const CompanyClass = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState('');
  const [sectorFilter,setSectorFilter]=useState<any>(null);
  
 
 
  const [selFilter, setSelFilter] = useState<any>(null);

  const getCompanyClass = async (): Promise<CompanyClassResponse[]> => {
    return (await apiCall().get('/SetUp/GetAllClassification')).data?.Data;
  };
  
  const {data, isFetching, isError, error} = useQuery(['get-all-classification', searchData], getCompanyClass, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });
  
  const getAllCompanyClassErrorMessage = (error as AxiosError)?.message

  const filteredData = data?.filter(x => (
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase()) 
  )) || [];
  
  return (
    <Container>
      <TopDisplay title="Company Classification" subTitle="All" Btn={<CreateBtn />} />
      <InnerContainer >
        <label className={styles.searchForm} >
            <span className={styles.sI}><SearchIcon/></span>
            <input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' />
            <button className={styles.rBtn} type="submit">
                <ReloadIcon/>
            </button>
        </label>
        <FilterDropDown onChange={setSelFilter} options={option1} text=" Membership Route" bg="#11643C" color="#fff" /> 
        {<FilterDropDown options={[
          {name:"Public",val:1},
          {name:'Private',val:2}
        ]} onChange={setSectorFilter}   text="Sector" bg="#E2E4E9"/> } 
        <Button onClick={()=>{setSectorFilter(null);setSearchData('')}} children='Reset Filter' />  
        
      </InnerContainer>
      { isFetching ?
      (<CircularProgress 
        sx={{
          fontSize: '1rem',
          marginInline: 'auto',
          display: 'block',
          marginBlock: '2rem'
        }}
      />
      ) : isError ? (
          <StyledError>{getAllCompanyClassErrorMessage}</StyledError>
      ) : 
      <CompanyClassTable data={
        !sectorFilter ? ( 
          filteredData?.length > 0 ? filteredData : data) : 
          (filteredData?.length > 0 ? filteredData : data)?.filter(
            eData=> Object.values(eData).join(" ").toLowerCase().includes(sectorFilter.name.toLowerCase())
            )} 
        />}

    </Container>
  )
}
export default CompanyClass;

export const Container = styled.div`
  padding: 0 20px 20px;
  width:100%;
`
export const InnerContainer = styled.div`
  display: flex;
  gap:10px;
  margin-top:20px;
`
const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const Wrapper = styled.div`

    display: flex;
    flex-direction: column;
    gap:10px;
    min-height: 450px;

 & > div:first-of-type{
    width: 100%;
    display:grid;
    border-bottom: 2px solid #E2E4E9;
    padding-bottom: 15px;
    gap:5px;
}
 & > div:first-of-type > *{
    color:#0F324D;
    font-size: 12px;
    font-weight: 500;
}
 & > div:nth-child(2){
    width: 100%;
    display: flex;
    flex-direction: column;
    gap:5px;
}
 &> div:nth-child(2) > *{
    flex:1;
    display:grid;
    gap:5px;
    border-left: 2px solid white;
    /* cursor: pointer; */
} &> div:nth-child(2) > *:hover{
    background-color: #E0FAEE;
    border-left-color:#293856;
}
 &> div:nth-child(2) > * > div{
    padding:10px 6px;
    text-overflow: ellipsis;
    /* overflow:hidden; */
    font-size: 12px;
   
}
 & > div:nth-child(2) > * > div:last-child{
    display:flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
 & > div:nth-child(2) > * > div:last-child > span{
    position: absolute;
    right:50px;
    background-color: var(--text-green);
    color:var(--white-color);
    padding:5px;
    border-radius: 2px;
    height: 20px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    display: none;
}
 & > div:nth-child(2) > * > .moreSpan{
    
    font-size: 16px;
    position: relative;
    
} & > div:nth-child(2) > *:hover > div:last-child > span{
    display: flex;
}
 & > div:nth-child(2) > * > div:last-child > span.activeMore{
    display:flex !important;
}

& .moreSpan > div{
    position: absolute;
    width:180px;
    display: flex;
    flex-direction: column;
    padding:10px 0;
    right:0;
    top:15px;
    z-index: 1;
    background-color: var(--white-color);
    border:1px solid #999;
    border-radius: 3px;
    color:#222;
}
& .moreSpan > div > div{
    flex:1;
    padding:5px 20px;
    font-size:13px ;
}
& .moreSpan > div > div:hover{
    background-color:#F1F1F1;
    ;
}

& .pagination{
    margin-top: auto;
    width: 100%;
    border-top: 2px solid #E2E4E9;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}
& .pagination > div{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap:8px;
    padding:0 30px;;
}

& .pagination > div > *{
    cursor: pointer;
}

& .pagination > div > .btn{
    position: absolute;
    align-self: center;
    border:none;
    outline:none;
    background-color: transparent;
    display: flex;
    padding:3px;
    font-size: 12px;
    top:0px;
}

& .pagination > div > span{
    /* border:1px solid red; */
    border-radius: 2px;
    font-size: 12px;
    height: 20px;
    width:20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

& .pagination > div > .lBtn{
    left:-10px;
}
& .pagination > div > .rBtn{
    right:-10px;
}
`

